import { koComponent } from '../ko-utils';

class TrialExpiredDialog {
    constructor(params, initParams) {
        this.page = initParams;
    }

    cancel() {
        this.page.closeDialog();
    }
}

export default koComponent('trial-expired-dialog', TrialExpiredDialog);